/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionTree } from "vuex";
import { RootState } from "../types";
import { DraftsInterface } from "./types";
import { JobsAPI } from "../../services/jobs/index";

export const actions: ActionTree<DraftsInterface, RootState> = {
  getAllDrafts({ commit }, obj) {
    return new Promise((resolve, reject) => {
      JobsAPI.getAllJobs(obj.filters, obj.page)
        .then((data: any) => {
          resolve(false);
          commit("DRAFTS_FULLFILED", data.data);
        })
        .catch((err) => {
          reject(true);
          commit("DRAFTS_REJECTED", err);
        });
    });
  },
};
